import { useAuthActions } from '@core-frontend/core-frontend';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from '@/app/app-router';

import type {
  RegisterRequest,
  RegisterResponse,
} from '@/widgets/auth/Register/models';

import { useMutate } from '@/shared/model/hooks';

import { registerAsync } from '../api';

export const useRegisterMutation = () => {
  const navigate = useNavigate();
  const { setUserEmail } = useAuthActions();
  return useMutate<
    RegisterResponse,
    { data: RegisterRequest; inCore?: boolean }
  >(({ data, inCore }) => registerAsync(data, inCore), {
    onMutate: ({ data: { email } }) => {
      setUserEmail(email);
    },
    onSuccess: () => navigate(AppRoutes.CHECK_YOUR_EMAIL_REGISTER),
  });
};
